import { Button } from 'blaze-components/WriterTopBar/Button'
import { Drawer } from 'components/Drawer'
import { Key, useMemo, useState } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import { observer } from 'mobx-react-lite'
import { Eraser } from 'blaze-ui/icons'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { TextStylesSubMenu } from './TestStylesSubMenu'
import { TextStylesMenu } from 'common/Prose/Toolbar/TextStylesMenu/TextStylesMenu'
import { MoreOptionsMenu } from '../MobileWriterFormatBar/MoreOptionsMenu'
import Styles from './TextStylesMenuDrawer.module.scss'
import { useClearFormattingButton } from 'common/Prose/Toolbar/hooks/useClearFormattingButton'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { Button as BlazeButton } from 'blaze-ui/Button'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

export const TextStylesMenuDrawer = observer((props: DrawerProps) => {
  const view = useEditorView()
  const { drawersStore } = useRootStore()
  const clearFormatting = useClearFormattingButton(view)
  const [subMenu, setSubMenu] = useState<string | undefined>(undefined)
  const [snap, setSnap] = useState<number | string | null>(0.7)

  const close = () => drawersStore.closeDrawer()

  const handleAction = (action: Key) => {
    switch (action) {
      case 'textStyle':
        return setSubMenu('textStyle')
      case 'fontFamily':
        return setSubMenu('fontFamily')
      case 'fontWeight':
        return setSubMenu('fontWeight')
      case 'fontSize':
        return setSubMenu('fontSize')
      case 'alignment':
        return setSubMenu('alignment')
      case 'textColor':
        return setSubMenu('textColor')
      case 'textHighlight':
        return setSubMenu('textHighlight')
      case 'callout':
        return setSubMenu('callout')
      case 'quote':
        return setSubMenu('quote')
    }
    drawersStore.closeDrawer()
  }

  // not yet supported in mobile
  const hiddenKeys = useMemo(() => new Set(['editStyles']), [])

  return (
    <Drawer.Root
      snapPoints={[0.7, 1]}
      activeSnapPoint={snap}
      setActiveSnapPoint={setSnap}
      fadeFromIndex={0}
      onClose={() => setSubMenu(undefined)}
      {...props}
    >
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.Handle />
          <Drawer.InnerContent isSnappedTop={snap === 1}>
            <Drawer.Top>
              <div>
                {!subMenu && <Drawer.Close />}
                {subMenu && <Button onPress={() => setSubMenu(undefined)} icon={ChevronLeft} />}
              </div>
              <Drawer.Title asChild>
                <Heading level={5}>Text Styles</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container>
              {subMenu && <TextStylesSubMenu menu={subMenu} menuType="tray" onAction={handleAction} />}
              {!subMenu && (
                <>
                  <TextStylesMenu
                    menuType="tray"
                    onAction={handleAction}
                    aria-label="Text Styles"
                    hiddenKeys={hiddenKeys}
                  />
                  <div className={Styles.moreOptionsContainer}>
                    <MoreOptionsMenu onAction={close} />
                  </div>
                  <div className={Styles.clearFormatButton}>
                    <BlazeButton
                      onPress={() => {
                        clearFormatting()
                        close()
                      }}
                      variant="secondary"
                      fullWidth
                      size="lg"
                      frontIcon={Eraser}
                    >
                      Clear Formatting
                    </BlazeButton>
                  </div>
                </>
              )}
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
